import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/mobile/drop-icon-gift-dialog.png'
import _imports_1 from '@/assets/images/mobile/image-gift-tapes.png'
import _imports_2 from '@/assets/images/mobile/apply-gift-dialog-title.png'


const _withScopeId = n => (_pushScopeId("data-v-693e2400"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "redeem-dialog pb-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "image-gift-tapes mt-2 position-absolute",
  alt: "gift-icon"
}, null, -1))
const _hoisted_3 = {
  key: 0,
  src: _imports_2,
  class: "img-cn-title mb-3",
  alt: "title"
}
const _hoisted_4 = {
  key: 1,
  class: "title text-black fw-semibold"
}
const _hoisted_5 = { class: "des mb-2" }
const _hoisted_6 = { class: "package-points mb-3 mx-auto d-flex justify-content-center align-items-center" }
const _hoisted_7 = { class: "package p-2 rounded-3" }
const _hoisted_8 = { class: "or mx-3" }
const _hoisted_9 = { class: "points p-2 rounded-3" }
const _hoisted_10 = { class: "group-s-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _imports_0,
      class: "drop-icon",
      alt: "drop icon",
      role: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.hide_()))
    }),
    _hoisted_2,
    (_ctx.$route.query.lang?.toString().toLowerCase() == 'cn')
      ? (_openBlock(), _createElementBlock("img", _hoisted_3))
      : (_openBlock(), _createElementBlock("p", _hoisted_4, "Select Reward")),
    _createElementVNode("p", _hoisted_5, _toDisplayString($setup.local.apply_gift_dialog_des), 1),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString($setup.props.gift?.packageName || '---'), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString($setup.local.or), 1),
      _createElementVNode("div", _hoisted_9, _toDisplayString($setup.props.gift?.points || '---') + _toDisplayString($setup.props.gift?.points ? $setup.local.apply_p : ''), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "package-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.submitGiftType_('package')))
      }, _toDisplayString($setup.local.apply_package), 1),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.submitGiftType_('points')))
      }, _toDisplayString($setup.local.apply_points), 1)
    ])
  ]))
}